module.exports = __webpack_public_path__ + "static/gopher-466e52305a9df04a69a78b9095e822cb.png";